// extracted by mini-css-extract-plugin
export default {"container":"RecordCompareRecordMetaData_container__9t3Uv","card-view":"RecordCompareRecordMetaData_card-view__ey64r","item":"RecordCompareRecordMetaData_item__JAUEc"};